export const CURRENCIES = [
    'EUR',
    'GBP',
    'SEK',
    'USD',
    'AUD',
    'CHF',
    'CAD',
    'JPY',
    'BRL',
    'DKK',
    'ARS',
] as const;
